
import {forkJoin as observableForkJoin,  Observable, forkJoin } from 'rxjs';
import { Component, OnInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Params, Router } from "@angular/router";
import { EditUserService } from "app/user/edit-user/edit-user.service";
import { UserResource } from "app/resources/user/user-resource";
import { RoleListResource } from "app/resources/role/role-list-resource";
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { RoleResource } from "app/resources/role/role-resource";
import { CompanyListResource } from "app/resources/company/company-list-resource";
import { CompanyResource } from "app/resources/company/company-resource";
import { AdminProfileResource } from "app/models/AdminProfileResource";
import { NotificationsService } from "angular2-notifications";
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from "app/services/utils.service";

@Component({
  selector: 'vbn-edit-user',
  providers: [EditUserService],
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {

  addressParams: any;
  userResource: UserResource;
  roleListResource: RoleListResource;
  companyListResource: CompanyListResource;
  errorMessage: string;
  showSuccessAlert = true;
  private timer;
  //adminProfileResource: AdminProfileResource;
  saveErrors: boolean = false;
  logoLang: any;
  selected_language: string = "ro";
  dateNow: Date;
  userRoleId = localStorage.getItem("_roleId");
  selectedClient = (localStorage.getItem("_sc") === null)? null:atob(localStorage.getItem("_sc"));


  constructor(
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute, 
    private editUserService: EditUserService, 
    private _router: Router, 
    private fb: FormBuilder, 
    private _notificationService: NotificationsService,
    private utilsService: UtilsService,
    private element: ElementRef) {
    this.userResource = new UserResource();
      this.userResource.role = new RoleResource();
      this.userResource.company = new CompanyResource();
      //this.userResource.company.rid = 1;
      this.roleListResource = new RoleListResource();
      this.companyListResource = new CompanyListResource();
      //this.adminProfileResource = new AdminProfileResource();
      this.dateNow = new Date();
      this.logoLang = '0';
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.addressParams = JSON.parse(atob(params['json']));
      //console.log(this.addressParams);
    });
    this.getUserProfile(this.addressParams.userEmail);
    this.getAllCompany();
    this.getUserRoles();
   // this.getAdminProfile();
  }

  editForm = this.fb.group({
    firstName: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3), Validators.pattern('^[a-zA-Z ]+'), this.utilsService.NoWhitespaceValidator()]], 
    // 3-100 de caractere pentru a interzice introducerea de spatiu
    lastName: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3), Validators.pattern('^[a-zA-Z ]+'), this.utilsService.NoWhitespaceValidator()]],
    companyName: ['', [Validators.required, Validators.maxLength(50), Validators.minLength(3), Validators.pattern('^[a-zA-Z ]+'), this.utilsService.NoWhitespaceValidator()]],
    email: ['', [Validators.required, Validators.maxLength(100), Validators.email]],
    phone: ['', [Validators.nullValidator]],
    address: ['', [Validators.nullValidator]],
    role: ['', [Validators.nullValidator]],
  })

  getUserProfile(email: string) {
    this.editUserService.getUserProfile('/admin/user/getProfile?userName=' + email)
      .subscribe(
      response => {
        this.userResource = response;
        if(this.userResource.isOneLogo) {
          this.logoLang = '0';
        } else {
          this.logoLang = '1';
        }
        // if(this.userResource.logoDe !== null){
        //   this.logoLang = "1"; // multi logo ; each for each language
        // }
      },
      error => this.errorMessage = <any>error);
  }

  getAllCompany() {
    this.editUserService.getAllCompany('admin/company/findAll')
      .subscribe(
      response => {
        console.log("Company list: ", response)
        this.companyListResource = response;
      },
      error => this.errorMessage = <any>error);
  }

  getUserRoles() {
    this.editUserService.getUserRoles('/admin/role/getAll')
      .subscribe(
      response => {
        this.roleListResource = response;
        //console.log("User roles: ", this.roleListResource)
      },
      error => this.errorMessage = <any>error);
  }

 /*  getAdminProfile() {
    this.editUserService.getAdminProfile('/admin/profile/get')
      .subscribe(
      response => {
        this.adminProfileResource = response;
      },
      error => this.errorMessage = <any>error);
  } */

  onSubmit() {
    this.saveErrors = true
    if (!this.editForm.valid) {
      observableForkJoin(
        [this.translate.get('Mising fields'),
        this.translate.get('Please fill out the fields!')]
    ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
    })
      //this._notificationService.create("Mising fields", 'Please fill out the fields!', 'error')
      return
    }

    //Logo validation
    if(this.logoLang === '0' && (this.userResource.logoStringRo == null && this.userResource.logoRo == null)){
        observableForkJoin(
          [this.translate.get('Mising fields'),
          this.translate.get('Please upload the logo RO!')]
        ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'error')
        })
        return
    }
    if(this.logoLang === '1' && ( (this.userResource.logoStringRo == null && this.userResource.logoRo == null) || 
              this.userResource.logoStringEn == null ||
              this.userResource.logoStringFr == null ||
              this.userResource.logoStringDe == null) &&
              (this.userResource.logoRo == null || 
                this.userResource.logoEn == null || 
                this.userResource.logoFr  == null || 
                this.userResource.logoDe == null)){
        observableForkJoin(
          [this.translate.get('Mising fields'),
          this.translate.get('Please upload the logo for all languages!')]
        ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'error')
        })
        return
    }

    this.userResource.firstName = this.utilsService.WhiteSpacesRemover(this.userResource.firstName);
    this.userResource.lastName = this.utilsService.WhiteSpacesRemover(this.userResource.lastName);
    this.userResource.isOneLogo = (this.logoLang === '0')? true: false;
    this.userResource.parrentUser = new UserResource();
    //this.userResource.parrentUser.email = this.selectedClient;

    this.editUserService.editUser('/admin/user/createEdit',this.userResource)
      .subscribe(
      response => {
        this.userResource = response;
        this.showSuccessAlert = false;
        observableForkJoin(
            [this.translate.get('Success'),
            this.translate.get('Successfully saved!')]
        ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
        })
        this._router.navigate([`/user-list`])
        this.timer = setTimeout(() => {
          this.showSuccessAlert = true;
        }, 5000);
        //console.log("Edit user succes")
      },
      error => this.errorMessage = <any>error);
  }
    back(){
       this._router.navigate([`/user-list`])
    }

    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          return false;
      }
      return true;
    }

    changeListenerMainImage($event, lang): void {
      console.log("FFEFFF: ", $event)
      var file: File = $event.target.files[0];
      var myReader: FileReader = new FileReader();
      var image = this.element.nativeElement.querySelector('#documentInput'+lang);
      if ((file.type.slice(0, 9) === "image/jpg") || (file.type.slice(0, 9) === "image/JPG") ||
        (file.type.slice(0, 10) === "image/jpeg") || (file.type.slice(0, 10) === "image/JPEG") ||
        (file.type.slice(0, 9) === "image/png") || (file.type.slice(0, 9) === "image/PNG") ||
        (file.type.slice(0, 9) === "image/gif") || (file.type.slice(0, 9) === "image/GIF")) {
        if (file.size < 1000000) {
          myReader.onloadend = (e: any) => {
            image.src = e.target.result;
            console.log("eddddddddddddddd", image);
            this.userResource["logoString"+lang] = e.target.result;
          }
          myReader.readAsDataURL(file);
        } else {
          forkJoin(
            [this.translate.get('Image error'),
            this.translate.get('Image size is more than 1 mb!')]
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'error')
          })
        }
      } else {
        forkJoin(
          [this.translate.get('Image error'),
          this.translate.get('Only these formats of image are allowed: JPG, JPEG, PNG, GIF!')]
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
      }
    }
  
}
